import { render, staticRenderFns } from "./decisiondialog-component.vue?vue&type=template&id=ab236878"
import script from "./decisiondialog-component.vue?vue&type=script&lang=ts"
export * from "./decisiondialog-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports